/**
 * Which tile the Traffic link dialog opens on. Voluum and Binom always have a
 * tile; Tres Commas only where it is enabled. Without its tile, a Tres Commas
 * link never opens the dialog (it would pre-select another tracker and one Save
 * would relabel the campaign): such a group is added to the stats tabs directly.
 * For Media Devoted | Created By Ciro Autiero
 */

import { assertNever, type TrackerId } from '@trafficpulse/shared';

import { statsTrafficProvider } from '@/features/trackers/stats-tracker';
import type { PatchTrafficProvider } from '@/hooks';
import type { StatsTrafficProvider, TabGroup } from '@/pages/admin/SmswiserCampaignDetailPage/types';

export function linkDialogProvider(
  provider: StatsTrafficProvider,
  enabled: readonly TrackerId[],
): PatchTrafficProvider | null {
  switch (provider) {
    case 'VOLUUM':
      return 'VOLUUM';
    case 'BINOM':
      return 'BINOM';
    case 'TRES_COMMAS':
      return enabled.includes('tres-commas') ? 'TRES_COMMAS' : null;
    default:
      return assertNever(provider, 'traffic provider');
  }
}

/** A campaign row (raw `trafficProvider`) can be linked through the dialog. */
export function campaignLinkEditable(
  campaign: { trafficProvider?: string | null },
  enabled: readonly TrackerId[],
): boolean {
  return linkDialogProvider(statsTrafficProvider(campaign.trafficProvider), enabled) !== null;
}

/** The active tab's group can be edited through the dialog (no group: as before). */
export function groupLinkEditable(group: TabGroup | undefined, enabled: readonly TrackerId[]): boolean {
  return !group || linkDialogProvider(group.trafficProvider, enabled) !== null;
}
